import { fireHeapEvent, getDrawerAction } from '../helpers'
import eventNames from '../constants/homepage'

const {
  userFocusedEmailInput,
  userEnteredValidEmail,
  userFocusedPasswordInput,
  userClickedHomepageUsecaseButton,
  userClickedHomepageMakeAFlowpageButton,
  userClickedHomepageLearnMoreAboutProButton,
  userClickedHomepageLearnMoreAboutTVButton,
  userChangedHomepageSlide,
  userClickedHomepageMakeAFlowcodeButton,
  userClickedHomepageFAQAccordion,
  userClickedProUpsellTopNavBanner,
  userClickedHomepagePlanCard,
  userClickedCreateAFlowcodeButton,
  userClickedExplorePlansButton,
  userClickedUploadALogoButton,
  userClickedAddFileButton,
  userClickedDownloadCodeButton,
  userClickedRefreshDesigns,
  userChangedAutoDesignOption,
  userCreatedGalleryCode,
  Flowcode_Homepage_Clicked_Generate_Code_Button,
  Flowcode_Simplified_Desktop_Homepage_Entered_Destination,
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Email,
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Google,
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Facebook,
  Flowcode_Simplified_Desktop_Homepage_Created_Account,
  Flowcode_Simplified_Desktop_Homepage_Created_Code,
  Flowcode_Simplified_Desktop_Homepage_Selected_Destination,
  Flowcode_Simplified_Desktop_Homepage_Selected_Pattern,
  Flowcode_Simplified_Desktop_Homepage_Selected_Color,
  Flowcode_Simplified_Desktop_Homepage_Uploaded_Image,
  Flowcode_Simplified_Desktop_Homepage_Selected_Shape,
  Flowcode_Simplified_Desktop_Homepage_Go_To_Step,
  Flowcode_Simplified_Desktop_Homepage_Go_Back,
  Flowcode_Simplified_Desktop_Homepage_Clicked_Click_Here,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Next_Btn,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Back_Btn,
  Flowcode_Combined_Funnel_Mobile_Homepage_Selected_Destination,
  Flowcode_Combined_Funnel_Mobile_Homepage_Entered_Destination,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Facebook,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Google,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Email,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Email,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Facebook,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Google,
  Flowcode_Combined_Funnel_Mobile_Homepage_SignedIn,
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Account,
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Code,
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Page,
  Flowcode_Combined_Funnel_Mobile_Homepage__Success_Clicked_View_Flowpage_Btn,
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Manage_Btn,
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_Btn,
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Preview_Btn,
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_My_Flowcode_Btn,
  Revenue_HomepageV1_Clicked_FAQTalkWithAnExpert,
  Revenue_HomepageV1_ScrolledTo_Section,
  Revenue_HomepageV1_Clicked_FAQVisitHelpcenter,
  Flowcode_LoggedOutGenerator_Clicked_TopBannerText,
  Flowcode_LoggedOutGenerator_Clicked_LowerBannerText
} = eventNames

const e = {
  userEnteredValidEmail(): void {
    fireHeapEvent(userEnteredValidEmail)
  },
  userFocusedPasswordInput(): void {
    fireHeapEvent(userFocusedPasswordInput)
  },
  userFocusedEmailInput(): void {
    fireHeapEvent(userFocusedEmailInput)
  },
  userClickedHomepageUsecaseButton(usecase: string): void {
    const formatedUsecase = usecase[0].toUpperCase() + usecase.substr(1)
    fireHeapEvent(userClickedHomepageUsecaseButton + formatedUsecase)
  },
  userClickedHomepageMakeAFlowpageButton(): void {
    fireHeapEvent(userClickedHomepageMakeAFlowpageButton)
  },
  userClickedHomepageLearnMoreAboutProButton(): void {
    fireHeapEvent(userClickedHomepageLearnMoreAboutProButton)
  },
  userClickedHomepageLearnMoreAboutTVButton(): void {
    fireHeapEvent(userClickedHomepageLearnMoreAboutTVButton)
  },
  userChangedHomepageSlide(): void {
    fireHeapEvent(userChangedHomepageSlide)
  },
  userClickedHomepageMakeAFlowcodeButton(): void {
    fireHeapEvent(userClickedHomepageMakeAFlowcodeButton)
  },
  userClickedHomepageFAQAccordion(
    section: { id: string; title: string } | null,
    opened: boolean
  ): void {
    fireHeapEvent(userClickedHomepageFAQAccordion, {
      drawer: section?.id,
      opened: getDrawerAction(opened),
      faqTitle: section?.title
    })
  },
  userClickedProUpsellTopNavBanner(): void {
    fireHeapEvent(userClickedProUpsellTopNavBanner)
  },
  userClickedHomepagePlanCard(properties: { title: string; cta: string; href: string }): void {
    fireHeapEvent(userClickedHomepagePlanCard, properties)
  },
  userClickedCreateAFlowcodeButton(): void {
    fireHeapEvent(userClickedCreateAFlowcodeButton)
  },
  userClickedExplorePlansButton(): void {
    fireHeapEvent(userClickedExplorePlansButton)
  },
  userClickedUploadALogoButton(): void {
    fireHeapEvent(userClickedUploadALogoButton)
  },
  userClickedAddFileButton(): void {
    fireHeapEvent(userClickedAddFileButton)
  },
  userClickedDownloadCodeButton(): void {
    fireHeapEvent(userClickedDownloadCodeButton)
  },
  userClickedRefreshDesigns(): void {
    fireHeapEvent(userClickedRefreshDesigns)
  },
  userChangedAutoDesignOption(path?: string): void {
    fireHeapEvent(userChangedAutoDesignOption, { path })
  },
  userCreatedGalleryCode(properties: { studioConfigId: string; name: string }): void {
    fireHeapEvent(userCreatedGalleryCode, properties)
  },
  Flowcode_Homepage_Clicked_Generate_Code_Button(): void {
    fireHeapEvent(Flowcode_Homepage_Clicked_Generate_Code_Button)
  },
  Flowcode_Simplified_Desktop_Homepage_Selected_Destination({
    destination,
    variant
  }: {
    destination: string
  } & { variant: number | undefined }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Selected_Destination, {
      destination,
      variant
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Selected_Pattern({
    pattern,
    variant
  }: {
    pattern: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Selected_Pattern, {
      pattern,
      variant
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Selected_Color({
    color,
    variant
  }: {
    color: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Selected_Color, {
      color,
      variant
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Uploaded_Image({
    fileName,
    variant
  }: {
    fileName: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Uploaded_Image, {
      fileName,
      variant
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Selected_Shape({
    shape,
    variant
  }: {
    shape: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Selected_Shape, {
      shape,
      variant
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Go_To_Step({
    pageLabel,
    variant
  }: {
    pageLabel: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Go_To_Step, {
      pageLabel,
      variant
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Go_Back({
    pageLabel,
    variant
  }: {
    pageLabel: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Go_Back, {
      pageLabel,
      variant
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Created_Code({
    batchId,
    variant
  }: {
    batchId: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Created_Code, { batchId, variant })
  },
  Flowcode_Simplified_Desktop_Homepage_Created_Account({ variant }: { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Created_Account, { variant })
  },
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Google({
    variant
  }: {
    variant: number
  }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Google, { variant })
  },
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Facebook({
    variant
  }: {
    variant: number
  }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Facebook, { variant })
  },
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Email({
    variant
  }: {
    variant: number
  }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Email, { variant })
  },
  Flowcode_Simplified_Desktop_Homepage_Entered_Destination({
    variant,
    destination
  }: {
    destination: string
  } & { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Entered_Destination, {
      variant,
      destination
    })
  },
  Flowcode_Simplified_Desktop_Homepage_Clicked_Click_Here({ variant }: { variant: number }): void {
    fireHeapEvent(Flowcode_Simplified_Desktop_Homepage_Clicked_Click_Here, { variant })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Next_Btn({
    variant,
    screen
  }: {
    variant?: string | null
    screen: string
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Next_Btn, {
      variant,
      screen
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Back_Btn({
    variant,
    screen
  }: {
    variant?: string | null
    screen: string
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Back_Btn, {
      variant,
      screen
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Selected_Destination({
    destination,
    variant,
    screen
  }: {
    destination: string
    variant?: string | null
    screen: string
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Selected_Destination, {
      destination,
      variant,
      screen
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Entered_Destination({
    variant,
    screen
  }: {
    variant?: string | null
    screen: string
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Entered_Destination, {
      variant,
      screen
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Email({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Email, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Email({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Email, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Google({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Google, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Google({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Google, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Facebook({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Facebook, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Facebook({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Facebook, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Account({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Created_Account, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_SignedIn({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_SignedIn, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Code({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Created_Code, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Page({
    variant
  }: {
    variant?: string | null
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Created_Page, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage__Success_Clicked_View_Flowpage_Btn({
    variant
  }: {
    variant: number
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage__Success_Clicked_View_Flowpage_Btn, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Manage_Btn({
    variant
  }: {
    variant: number
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Manage_Btn, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_Btn({
    variant
  }: {
    variant: number
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_Btn, {
      variant
    })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Preview_Btn({
    variant,
    screen
  }: {
    variant?: string | null
    screen: string
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Preview_Btn, { variant, screen })
  },
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_My_Flowcode_Btn({
    variant
  }: {
    variant: number
  }): void {
    fireHeapEvent(Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_My_Flowcode_Btn, {
      variant
    })
  },
  Revenue_HomepageV1_ScrolledTo_Section(section: string): void {
    fireHeapEvent(Revenue_HomepageV1_ScrolledTo_Section, { section })
  },
  Revenue_HomepageV1_Clicked_FAQTalkWithAnExpert(linkHref: string): void {
    fireHeapEvent(Revenue_HomepageV1_Clicked_FAQTalkWithAnExpert, { linkHref })
  },
  Revenue_HomepageV1_Clicked_FAQVisitHelpcenter(linkHref: string): void {
    fireHeapEvent(Revenue_HomepageV1_Clicked_FAQVisitHelpcenter, { linkHref })
  },
  Flowcode_LoggedOutGenerator_Clicked_TopBannerText({ linkText }: { linkText: string }): void {
    fireHeapEvent(Flowcode_LoggedOutGenerator_Clicked_TopBannerText, { linkText })
  },
  Flowcode_LoggedOutGenerator_Clicked_LowerBannerText({ linkText }: { linkText: string }): void {
    fireHeapEvent(Flowcode_LoggedOutGenerator_Clicked_LowerBannerText, { linkText })
  }
}

export default e
